/**
 * The external dependencies.
 */
import {combineReducers} from 'redux';
import {handleActions} from 'redux-actions';
import * as R from 'ramda';
/**
 * The internal dependencies.
 */
import {getResidueTasks, getSortingInitialValue, updateTask} from './utilities';
import Steps from '../../assets/data/steps.json';
import Workplaces from '../../assets/data/workplaces.json';
import store from '../../store';
import {
    resetCurrentTracking, resetLoading,
    resetOverlay, resetTasksFormatted,
    setCurrentTracking, setCustomFilter, setErpFilter, setOrderFilter,
    setOverlay, setTasksFormatted,
    setworkstepcount,
    storeTask,
    tasksAcceptErrormessage,
    tasksAllWorkStepsReceive,
    tasksDeselect,
    tasksInitSortingPagination, tasksPause,
    tasksReceive, tasksRecievedChildren,
    tasksRecievedErrormessage, tasksRecievedHandbook, tasksRecievedInstructions, tasksRequest,
    tasksSelect,
    tasksSetSorting,
    tasksSetSortingPagination,
    tasksStepsReceive,
    tasksUpdate,
    tasksWorkplacesReceive,
    tasksWorkStepsReceive,
} from './actions';
import {dispoTaskUpdate} from "../dispo/actions";
import {endRequestWithError} from "../requests/actions";

/**
 * Track tasks items
 * @type   {Function}
 * @return {Object}
 */
const items = handleActions({
    [tasksReceive]: (state, {payload: {tasks, orders}}) => [
        ...getResidueTasks(tasks, orders),
        ...tasks
    ],
    [tasksUpdate]: (state, {payload: {id, data}}) => {

        const updated = R.clone(state);
        const index = R.findIndex(R.propEq('id', id))(updated);
        const task = updated[index];
        const replaceTask = newData => updated.splice(...[index, 1, newData].filter(arg => arg !== null));

        return updateTask(id, data, updated)

    },
    [tasksPause]: (state, {payload: {id, data}}) => {

        const updated = R.clone(state);
        const index = R.findIndex(R.propEq('id', id))(updated);
        const task = updated[index];
        const replaceTask = newData => updated.splice(...[index, 1, newData].filter(arg => arg !== null));

        return updateTask(id, data, updated)

    },
    [dispoTaskUpdate]: (state, {payload: {id, data}}) => {
        const updated = R.clone(state);
        return updateTask(id, data, updated)
    },
    [tasksSetSortingPagination]: (state, {payload}) => [],
}, []);

/**
 * Track tasks orders
 * @type   {Function}
 * @return {Object}
 */
const orders = handleActions({
    [tasksReceive]: (state, {payload: {orders}}) => orders,
}, []);

/**
 * Track tasks steps
 * @type   {Function}
 * @return {Object}
 */
const steps = handleActions({
    [tasksStepsReceive]: (state, {payload: {steps}}) => {
        return steps
    }
}, Steps);

/**
 * Track tasks steps
 * @type   {Function}
 * @return {Object}
 */
const workSteps = handleActions({
    [tasksWorkStepsReceive]: (state, {payload: {workSteps}}) => {
        // console.log("tasksWorkStepsReceive", workSteps);
        return workSteps === undefined ? state : workSteps;
    }
}, []);

const allWorkSteps = handleActions({
    [tasksAllWorkStepsReceive]: (state, {payload: {workSteps}}) => {
        // console.log("tasksAllWorkStepsReceive", workSteps);
        return workSteps === undefined ? state : workSteps;
    }
}, []);

/**
 * Track tasks workplaces
 * @type   {Function}
 * @return {Object}
 */
const workplaces = handleActions({
    [tasksWorkplacesReceive]: (state, {payload: {workplaces}}) => workplaces
}, Workplaces);


/**
 * Track tasks sorting
 * @type   {Function}
 * @return {Object}
 */
const sorting = handleActions({
    [tasksSetSorting]: (state, {payload: {sorting}}) => sorting,
}, 'week');

const erpFilter = handleActions({
    [setErpFilter]: (state, {payload: {filter}}) => filter,
}, '');

const orderFilter = handleActions({
    [setOrderFilter]: (state, {payload: {filter}}) => filter,
}, '');

const customFilter = handleActions({
    [setCustomFilter]: (state, {payload}) => payload,
}, {});

/**
 * Track tasks sorting
 * @type   {Function}
 * @return {Object}
 */
const sortingPaginationValue = handleActions({
    [tasksSetSortingPagination]: (state, {payload: {value}}) => value,
    [tasksInitSortingPagination]: (state, {payload: {sorting}}) => getSortingInitialValue(sorting),
}, null);

/**
 * Track currently selected order
 * @type   {Function}
 * @return {Object}
 *
 *
 *
 */
const current = handleActions({
    [tasksSelect]: (state, {payload: {task}}) => task,
    [tasksDeselect]: (state, {payload}) => {
        return {};
    },
    [tasksUpdate]: (state, {payload: {id, data}}) => {

        const updated = R.clone(state);
        if (updated.id === id) {
            return {...updated, ...data};
        } else {
            return updated;
        }


    },
    [dispoTaskUpdate]: (state, {payload: {id, data}}) => {

        const updated = R.clone(state);
        if (updated.id === id) {
            return {...updated, ...data};
        } else {
            return updated;
        }


    },

}, {});

const currentChildren = handleActions({
    [tasksRecievedChildren]: (state, {payload: {value}}) => {
        return R.defaultTo([], value['_embedded'].task);
    },
    [tasksDeselect]: (state, {payload}) => {
        return [];
    },
}, []);

const currentInstructions = handleActions({
    [tasksRecievedInstructions]: (state, {payload: {value}}) => {
        if (value['_embedded']) {
            return R.defaultTo([], value['_embedded'].instruction);
        } else {
            return [];
        }
    },
    [tasksDeselect]: (state, {payload}) => {
        return [];
    },
}, []);

const currentHandbook = handleActions({
    [tasksRecievedHandbook]: (state, {payload: {value}}) => {
        return value
    },
    [tasksDeselect]: (state, {payload}) => {
        return '';
    },
}, '');

const errormessage = handleActions({
    [tasksRecievedErrormessage]: (state, {payload: value}) => {
        return R.pluck('content', value.value);
    },
}, []);

const errormessageRevieved = handleActions({
    [tasksRecievedErrormessage]: (state, payload) => {
        return true;
    },
    [tasksSelect]: (state, payload) => {
        return false;
    },
    [tasksAcceptErrormessage]: (state, {payload: task}) => {
        return false;
    },
}, []);


const overlay = handleActions({
    [setOverlay]: (state, {payload: {task}}) => {
        let buttons = [];
        let text = '';
        let display = false;

        switch (task.type) {
            case 'completeTask': {
                let step = +task.task.step + 1;
                text = step >= task.workstepcount ? `Der Auftrag wurde abgeschlossen` : `Der Arbeitsschritt wurde abgeschlossen - der Auftrag ist jetzt bereit für den Schritt ${step}`;
                buttons.push({name: 'button2', action: 'shop', label: 'OK'});
                display = true;
                break;
            }
            case 'reserveTask': {
                text = `Der Auftrag ${task.task.erpnumber} (${task.task.order_client}) wurde in Deinen persönlichen Vorrat gelegt.`;
                buttons.push({name: 'button1', action: 'shop', label: 'weitere Aufträge auswählen'});
                buttons.push({name: 'button2', action: 'stock', label: 'zum Vorrat'});
                display = true;
                break;
            }
            case 'logout': {
                text = `Möchtest du dich wirklich ausloggen? `;
                buttons.push({name: 'button1', action: 'logout', label: 'Logout'});
                display = true;
                break;
            }
            default:
        }

        return {text: text, buttons: buttons, display: display};
    },
    [resetOverlay]: () => {
        return {text: null, buttons: null, display: false};
    },
}, {});

const currentTracking = handleActions({
    [setCurrentTracking]: (state, {payload}) => {
        return payload;
    },
    [resetCurrentTracking]: (state, {payload}) => {
        return {};
    },
}, {});

const workstepcount = handleActions({
    [setworkstepcount]: (state, {payload: {value}}) => {
        return value
    }
}, 15);

const formattedTasksColumns = handleActions({
    [setTasksFormatted]: (state, {payload: {tasks, columns}}) => {
        return {tasks, columns};
    },
    [tasksRequest]: (state, {payload}) => {
        return {tasks: [], columns: []};
    },
    [tasksSetSortingPagination]: (state, {payload}) => {
        return {tasks: [], columns: []};
    }
}, {tasks: [], columns: []});

const loadingTasks = handleActions({
    [tasksRequest]: (state, {payload}) => {
        return true;
    },
    [tasksSetSortingPagination]: (state, {payload}) => {
        return true;
    },
    [tasksReceive]: (state, {payload}) => {
        return false;
    },
    [resetLoading]: (state, {payload}) => {
        return false;
    },
    [endRequestWithError]: (state, {payload}) => {
        return false;
    },
}, false);

export default combineReducers({
    items,
    orders,
    steps,
    workSteps,
    allWorkSteps,
    workplaces,
    sorting,
    sortingPaginationValue,
    current,
    tasksRecievedErrormessage,
    errormessage,
    errormessageRevieved,
    overlay,
    currentTracking,
    workstepcount,
    currentChildren,
    currentInstructions,
    erpFilter,
    orderFilter,
    customFilter,
    currentHandbook,
    loadingTasks,
    formattedTasksColumns,
});



// WEBPACK FOOTER //
// ./src/store/tasks/reducer.js